export const POST_COMPLETION_EDITABLE_FIELDS = [
  'budget_setting_hash_id',
  'pay_factor_source',
  'pay_factor',
  'fixed_payout',
  'distribution_percentage',
];

const NUMERIC_FIELDS = [
  'pay_factor',
  'fixed_payout',
  'distribution_percentage',
];

export const normalizePostCompletionValue = (field, value) => {
  if (NUMERIC_FIELDS.includes(field)) {
    if (value === '' || value === null || value === undefined) return null;

    const numeric = Number(String(value).replace(',', '.'));
    return Number.isNaN(numeric) ? String(value) : numeric;
  }

  return value ?? null;
};

export const hasCompletedSettingsChanges = (formData, originalValues) => (
  POST_COMPLETION_EDITABLE_FIELDS.some((field) => (
    normalizePostCompletionValue(field, formData?.[field])
    !== normalizePostCompletionValue(field, originalValues?.[field])
  ))
);

export const buildCompletedSettingsPayload = (formData) => (
  POST_COMPLETION_EDITABLE_FIELDS.reduce((payload, field) => {
    payload[field] = field === 'budget_setting_hash_id'
      ? (formData?.[field] || null)
      : formData?.[field];
    return payload;
  }, {})
);
